import React from "react"
import { Layout } from "../common/components"
import Main from "../modules/login/main"

export default () => (
  <Layout>
    <Main />
  </Layout>
)
